/**
 * Открывает странице право играть звук — ровно в тот момент, когда человек нажал «Ответить».
 *
 * <p>Safari разрешает воспроизведение только из пользовательского жеста, а голос собеседника
 * приходит секундой позже: комната к моменту нажатия ещё не создана, и позвать у неё
 * `startAudio()` изнутри жеста невозможно. Поэтому в жесте проигрывается пустой звук — этого
 * достаточно, чтобы браузер счёл страницу «разрешённой», и подключившийся следом поток пошёл
 * без запроса.
 *
 * <p>Что это лечит: на iPhone треть звонков упиралась в заблокированное воспроизведение
 * (12 из 37 по телеметрии за месяц) — человек отвечал и не слышал ничего, пока не находил
 * баннер «нажмите, чтобы включить звук». Баннер остаётся страховкой; это — попытка не доводить
 * до него.
 *
 * <p>Отказ здесь ничего не ломает и не логируется: браузер имеет полное право не разрешить, и
 * тогда всё работает как раньше.
 */

/** Секунда тишины: самый короткий wav, который Safari принимает как настоящий источник. */
const SILENCE =
  'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';

let primed: HTMLAudioElement | null = null;

export const primeAudioPlayback = (): void => {
  if (typeof window === 'undefined' || typeof Audio === 'undefined') {
    return;
  }
  try {
    if (!primed) {
      primed = new Audio(SILENCE);
      primed.loop = false;
      // Звук пустой, но громкость на нуле — страховка на случай, если браузер когда-нибудь
      // начнёт отдавать в него что-то своё.
      primed.volume = 0;
    }
    primed.currentTime = 0;
    void primed.play().catch(() => undefined);
  } catch {
    // Не разрешили — останется баннер «включить звук» в окне разговора.
  }
};
